import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class ComponentDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'elements',
      type: 'Schema.Element'
    },
    {
      items: {
        type: 'Schema.TypedSchema'
      },
      name: 'props',
      type: 'Schema.Array'
    },
    {
      items: {
        type: 'Schema.Query'
      },
      name: 'queries',
      type: 'Schema.Array'
    },
    {
      items: {
        type: 'Schema.Variable'
      },
      name: 'variables',
      type: 'Schema.Array'
    }
  ]
}
